module.exports = __webpack_public_path__ + "static/media/matilde-cap-brazil-bored.f3384aaf.png";